import { Link } from "react-router-dom";
import { SEO } from "@/components/SEO";

export default function NotFound() {
  return (
    <div className="container-x py-24 text-center" data-testid="not-found-page">
      <SEO title="Page Not Found | Mynavodayans" description="The page you are looking for does not exist." noindex />
      <p className="font-heading text-6xl font-extrabold text-[#d4a017]">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-[#0a192f]">This page doesn't exist</h1>
      <p className="mt-2 text-slate-600">It may have been moved or unpublished.</p>
      <div className="mt-6 flex justify-center gap-3">
        <Link to="/" className="btn-navy" data-testid="nf-home-btn">Go Home</Link>
        <Link to="/services" className="btn-gold" data-testid="nf-services-btn">Browse Services</Link>
      </div>
    </div>
  );
}
